// Asset TCO: composed total cost of ownership for a single asset.

export const FETCH_ASSET_TCO = 'FETCH_ASSET_TCO';
export const FETCH_ASSET_TCO_SUCCESS = 'FETCH_ASSET_TCO_SUCCESS';
export const FETCH_ASSET_TCO_FAIL = 'FETCH_ASSET_TCO_FAIL';
export const CLEAR_ASSET_TCO = 'CLEAR_ASSET_TCO';
